import React from 'react'
import AddCoursePage from '../components/core/AddCourse'
export default function AddCourse() {
  return (
    <>
    <AddCoursePage></AddCoursePage>
    </>
  )
}
